module.exports = __webpack_public_path__ + "static/media/bk-wall-icon-active.9f81a84f.svg";